import { AddEditEmployee, EmployeeMgmt } from "@/pages";
import { routes } from "../utils";

export const EmployeeMgmtRoutes = () => {
  return {
    path: routes.employeeMgmt,
    children: [
      {
        path: "",
        element: <EmployeeMgmt />,
      },
      {
        path: routes.add,
        element: <AddEditEmployee />,
      },
      {
        path: routes.id + "/" + routes.action,
        element: <AddEditEmployee />,
      },
    ],
  };
};
